// extracted by mini-css-extract-plugin
export default {"animated":"Table_animated__YOY5F","TableLoading":"Table_TableLoading__TQAHu"};